//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    report: {
      default: null,
      type: Object
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  }
}

